import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import tippy from "tippy.js";
import { namespace, Getter } from 'vuex-class';

import { storeModules } from '../../store';
import NavbarComponent from './components/NavbarComponent.vue';
import LanguageComponent from './components/LanguageComponent.vue';
import NotificationComponent from './components/NotificationComponent.vue';
import RunningTasksComponent from './components/RunningTasksComponent.vue';
import ProfileComponent from './components/ProfileComponent.vue';
import MailboxComponent from './components/MailboxComponent.vue';
import MoreMenuComponent from './components/MoreMenuComponent.vue';
import GlobalSearch from './components/GlobalSearchComponent.vue';
import AIAssistantButton from './components/ai-assistant/AIAssistantButton.vue';
import i18n from '../../i18n';
import { LabelSetting } from '../../i18n/locale-helper';
import { ROUTER } from '../../common/constants';
import MissedIncomingCall from "./components/missed-call";

const GlobalMenuComponent = () => import("./components/GlobalMenuComponent.vue");
const SendMessageViewModal = () => import('../../containers/report/send-message/SendMessageModalComponent.vue');
const PrintTemplateViewModal = () => import('../../containers/report/print-template/PrintTemplateModalComponent.vue');
const LargeMailingViewModal = () => import('../../containers/report/large-mailing/LargeMailingModalComponent.vue');

const CommonGetter = namespace(storeModules.Common, Getter);

Vue.directive("tippy-user", {
	inserted: (el, binding, vnode) => {
		tippy(el, {
			content: "<i class=\"el-icon-loading\"></i>",
			delay: 100,
			arrow: true,
			touch: true,
			interactive: true,
			hideOnClick: true,
			trigger: "click",
			placement: 'bottom-end',
			onShow(tip: any) {
				try {
					if (!(vnode.context as any).userMenuComponent) {
						(vnode.context as any).initUserMenuComponent();
					}
					tip.setContent((vnode.context as any).userMenuComponent.$el)
				} catch (e) {
					tip.setContent('');
				}
			},
			onHidden(tip: any) {
				tip.setContent('');
			},
		});
	}
});

Vue.directive("tippy-more-button", {
	inserted: (el, binding, vnode) => {
		tippy(el, {
			content: "<i class=\"el-icon-loading\"></i>",
			delay: 100,
			arrow: true,
			touch: true,
			interactive: true,
			hideOnClick: true,
			trigger: "click",
			placement: 'bottom-end',
			onShow(tip: any) {
				try {
					if (!(vnode.context as any).moreMenuComponent) {
						(vnode.context as any).initMoreMenuComponent();
					}
					tip.setContent((vnode.context as any).moreMenuComponent.$el)
				} catch (e) {
					tip.setContent('');
				}
			},
			onHidden(tip: any) {
				tip.setContent('');
			},
		});
	}
});

@Component({
	template: require('./template01.html'),
	components: {
		'header-navbar': NavbarComponent,
		'header-notification': NotificationComponent,
		'header-mailbox': MailboxComponent,
		'header-language': LanguageComponent,
		'header-profile': ProfileComponent,
		'header-global-menu': GlobalMenuComponent,
		'header-global-search': GlobalSearch,
		'header-running-tasks': RunningTasksComponent,
		'send-message-view-modal': SendMessageViewModal,
        'print-template-view-modal': PrintTemplateViewModal,
        'large-mailing-view-modal': LargeMailingViewModal,
		'missed-incoming-call' : MissedIncomingCall,
        'common-upload': () => import("../../components/new-upload"),
		'header-ai-assistant': AIAssistantButton,
        MoreMenuComponent,
	}
})
class HeaderContainer extends Vue {
	@Prop({ type: Boolean, default: false }) isAssistantOpen!: boolean;
	@Prop({ type: Boolean, default: false }) isAiAssistantEnabled!: boolean;

	public moreMenuComponent: any = null;

	constructor() {
		super();
	}

	@CommonGetter('sendMessageModalVisible') sendMessageModalVisible: boolean;
    @CommonGetter('largeMailingModalVisible') largeMailingModalVisible: boolean;
	@CommonGetter('printTemplateModalVisible') printTemplateModalVisible: boolean;
	@CommonGetter('printTemplateModalProps') printTemplateModalProps: any;
	@CommonGetter('sendMessageModalProps') sendMessageModalProps: any;

	handleUpdateInternet() {
		this.$closeTippy();
		this.$router.push({
			name: ROUTER.PORTAL.PORTAL_UPDATE_INTERNET
		})
	}

	handleMediaStatistic() {
		this.$closeTippy();
		this.$router.push({
			name: ROUTER.PORTAL.PORTAL_MEDIA_STATISTIC
		})
	}

	initMoreMenuComponent() {
		this.moreMenuComponent = (new MoreMenuComponent({
			i18n: i18n,
			data() {
				return {
					lblSetting: LabelSetting
				}
			},
			methods: {
				handleUpdateInternet: () => this.handleUpdateInternet(),
				handleMediaStatistic: () => this.handleMediaStatistic()
			}
		})).$mount();
	}
    mounted() {
        setTimeout(() => {
            this.$emit('render');
        }, 500);
	}
}

export default HeaderContainer;